export default __webpack_public_path__ + "static/media/4_3.b2a5d9db.png";